// Libs
import React from 'react';
import useTranslator from 'UTILS/hooks/useTranslator';
import { useSelector } from 'react-redux';
import { useTheme } from '@material-ui/core/styles';


// Components
import Dialog from '@material-ui/core/Dialog';
import Box from '@material-ui/core/Box';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';

// Utils
import translations from './locales.json';

const ClickToCallModal = ({
  open = false,
  onClose = () => {},
}) => {
  const [translate] = useTranslator(translations);
  const theme = useTheme();
  const supportPhoneNumber = useSelector(state => state.app.supportPhoneNumber);

  return (
    <Dialog maxWidth='md' open={open} onClose={onClose}>
      <Box className='clickToCallModal-container' >
        <Box bgcolor={theme.palette.secondary.dark} color={theme.palette.secondary.contrastText} className='clickToCallModal-header'>
          <Typography variant='h5' >{translate('helpRequest')}</Typography>
          <IconButton edge='end' onClick={onClose} style={{ color: theme.palette.secondary.contrastText }} ><CloseIcon /></IconButton>
        </Box>
        <Box className='clickToCallModal-footer'>
          <Typography paragraph>
            {translate('ifYouHaveAnyDifficultiesYouCanCall')} <a href={`tel:${supportPhoneNumber.replace(/[^+\d]/g, '')}`} >{supportPhoneNumber}</a>.
          </Typography>
        </Box>
      </Box>
    </Dialog>
  );
};

export default ClickToCallModal;
